import qs from "qs";

const VISIT_STORAGE_KEY = "taptype_source_visit_id";

/** Laravel `uuid` rule (RFC 4122). */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const REFERRAL_QUERY_KEYS = ["source", "source_visit_id"];

export const isSourceVisitId = (value) => typeof value === "string" && UUID_RE.test(value.trim());

/** RFC 4122 v4 without extra dependencies (Laravel `uuid` validation). */
const randomUuidV4 = () =>
	"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
		const random = Math.floor(Math.random() * 16);
		const value = char === "x" ? random : (random & 0x3) | 0x8;

		return value.toString(16);
	});

export const createSourceVisitId = () => {
	if (typeof window !== "undefined" && typeof window.crypto?.randomUUID === "function") {
		return window.crypto.randomUUID();
	}

	return randomUuidV4();
};

export const getSourceKeyFromSearch = (search = "") => {
	const parsed = qs.parse(search, { ignoreQueryPrefix: true });

	return typeof parsed?.source === "string" && parsed.source.trim() !== "" ? parsed.source.trim() : null;
};

const persistSourceVisitId = (id) => {
	try {
		sessionStorage.setItem(VISIT_STORAGE_KEY, id);
	} catch {
		// ignore
	}
};

export const getOrCreateSourceVisitId = (search = "") => {
	const parsed = qs.parse(search, { ignoreQueryPrefix: true });
	const fromQuery =
		typeof parsed?.source_visit_id === "string" && parsed.source_visit_id.trim() !== ""
			? parsed.source_visit_id.trim()
			: null;

	if (fromQuery && isSourceVisitId(fromQuery)) {
		persistSourceVisitId(fromQuery);

		return fromQuery;
	}

	try {
		const stored = sessionStorage.getItem(VISIT_STORAGE_KEY);
		if (stored && isSourceVisitId(stored)) {
			return stored;
		}
	} catch {
		// ignore
	}

	const created = createSourceVisitId();
	persistSourceVisitId(created);

	return created;
};

export const pickSourceAttributionQuery = (search = "") => {
	const parsed = qs.parse(search, { ignoreQueryPrefix: true });
	const source = getSourceKeyFromSearch(search);
	const source_visit_id = getOrCreateSourceVisitId(search);

	if (!source) return {};

	return {
		...(source ? { source } : {}),
		...(source_visit_id ? { source_visit_id } : {}),
	};
};

export const appendSourceAttributionToUrl = (baseUrl = "", search = "") => {
	const attribution = pickSourceAttributionQuery(search);
	if (!attribution?.source) return baseUrl;

	const hasQuery = baseUrl.includes("?");
	const joiner = hasQuery ? "&" : "?";

	return `${baseUrl}${joiner}${qs.stringify(attribution)}`;
};
